// 1.区分开发环境和生产环境
// export const URL_BASE = 'http://coderwhy.dev:8000'
// export const URL_BASE = 'http://codercba.prod:8000'

// 2.代码逻辑判断, 判断当前环境
// vite默认提供的环境变量
// (import.meta.env.MODE)
// (import.meta.env.DEV) // 是否开发环境
// (import.meta.env.PROD) // 是否生产环境
// (import.meta.env.SSR) // 是否是服务器端渲染(server side render)

// (`[import.meta.env]:`, import.meta.env);

let URL_BASE = ''
let URL_ADMIN = ''
// (`[import.meta.env.MODE]:`, import.meta.env.MODE)
// if (import.meta.env.PROD) {
//   // 生产环境
//   // URL_BASE = 'https://mtclccd.com/iot_server/'
//   URL_BASE = 'https://develop.mtclccd.com/test_server/'
//
// } else {
//   // 开发环境
//   URL_BASE = "http://127.0.0.1:38082/app-api";
// }

// 3.通过创建.env文件直接创建变量
URL_BASE = `${import.meta.env.VITE_API_URL_BASE}${import.meta.env.VITE_API_PREFIX_BASE}`
URL_ADMIN = `${import.meta.env.VITE_API_URL_BASE}${import.meta.env.VITE_API_PREFIX_ADMIN}`

export const TIME_OUT = 500000
export { URL_BASE, URL_ADMIN }
